import { CardType } from 'types/deck'
import { LocalCardData } from 'components/card/deckCards/deckCardWrapper'

import FoilSquare from 'components/card/controlsAndInfo/foilSquare'

import { colorsToColorIdentityName } from 'utils/colorUtils'
import { getScryfallImageUrl } from 'utils/ImageUrl'
import { CardText, createTypeLine, manaArrayToElement } from 'components/misc/customIcons/ManaSymbol/helpers'

import styles from './drawerTopper.module.scss'
import mtgColorBorders from '../deckCards/mtgColorBorders.module.scss'

type Props = {
  card: CardType
  localCardData?: LocalCardData
  includeCardText?: boolean
  flipped?: boolean
  className?: string
}

export const Background = ({ card, className = '' }: Props) => (
  <div
    className={`${styles.background} ${className}`}
    style={{ backgroundImage: `url(${getScryfallImageUrl(card.uid, card.flippedDefault, 'art_crop')})` }}
  />
)

const DrawerTopper = ({ card, localCardData, includeCardText, flipped }: Props) => {
  const colorIdentityName = colorsToColorIdentityName(card.colorIdentity)

  const colorBorderClassName = mtgColorBorders[colorIdentityName]
    ? mtgColorBorders[colorIdentityName]
    : mtgColorBorders.MultiColor

  return (
    <div className={styles.customMenuOption}>
      <div className={`${styles.cardMenu} ${includeCardText ? styles.autoHeight : ''} ${colorBorderClassName}`}>
        <div className={styles.cardName}>
          {card.name} {manaArrayToElement(card.castingCost)}
        </div>

        {includeCardText && (
          <>
            <div className={styles.typeLine}>{createTypeLine(card, false, true)}</div>

            <div className={styles.cardText}>
              {flipped ? (
                <CardText input={card.back?.text || card.text} />
              ) : (
                <CardText input={card.front?.text || card.text} />
              )}
            </div>
          </>
        )}

        <div className={styles.info}>
          <span>Quantity {localCardData?.quantity ?? card.qty}</span>
          <FoilSquare card={card} includeLabel />
        </div>

        <Background card={card} localCardData={localCardData} />
      </div>
    </div>
  )
}

export default DrawerTopper
